import state from '@/vuex-store/delivery-charge-area-control/state';
import mutations from '@/vuex-store/delivery-charge-area-control/mutations';
import getters from '@/vuex-store/delivery-charge-area-control/getters';
import actions from '@/vuex-store/delivery-charge-area-control/actions';
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
